import script from "./ButtonPrimitive.vue?vue&type=script&setup=true&lang=ts"
export * from "./ButtonPrimitive.vue?vue&type=script&setup=true&lang=ts"

import "./ButtonPrimitive.vue?vue&type=style&index=0&id=c384d632&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c384d632"]])

export default __exports__